import React from "react";
import { tickerMessages } from "../../data/mock";

export default function TickerBar() {
  const items = [...tickerMessages, ...tickerMessages, ...tickerMessages];
  return (
    <div className="w-full bg-[var(--slate-950)] text-[var(--off-white)] overflow-hidden">
      <div className="ticker-track py-2">
        {items.map((msg, i) => (
          <span key={i} className="flex items-center px-6 font-mono-sans text-[11px] font-semibold whitespace-nowrap">
            <span className="w-1.5 h-1.5 bg-[var(--terracotta)] mr-3" />
            {msg}
          </span>
        ))}
      </div>
    </div>
  );
}
